module.exports = __webpack_public_path__ + "static/logit-bw-9ac78d26896a9db559358d1a9ed7817b.jpg";